// 权限设置
import req from './index'
// 获取当前用户信息
export const getUserInfo = (params) => {
  return req.get('api/admin.php?service=Admin.Airport.GetUserList', params)
}
// 获取权限信息
export const getPurviewInfo = (params) => {
  return req.get('api/admin.php?service=Admin.Airport.GetUserLimitation', params)
}
// 提交权限信息
export const setPurviewInfo = (params) => {
  return req.get('api/admin.php?service=Admin.Airport.SetUserLimitation', params)
}